import cn from 'clsx';
import React from 'react';

import { Body1, Heading1, Heading2, useDeviceType } from '@cian/ui-kit';

import styles from './styles.css';

export type TFeatureHighlightBulletSurface = 'neutral' | 'main';

export interface IFeatureHighlightItem {
  title: string;
  description: string;
  bullet: React.ReactNode;
}

interface IFeatureHighlightListProps {
  items: IFeatureHighlightItem[];
  bulletSurface?: TFeatureHighlightBulletSurface;
}

export const FeatureHighlightList: React.FC<IFeatureHighlightListProps> = ({ items, bulletSurface = 'neutral' }) => {
  const deviceType = useDeviceType();
  const ItemTitle = deviceType === 'desktop' ? Heading1 : Heading2;

  return (
    <div className={cn(styles['list'], styles[deviceType])}>
      {items.map((item, index) => (
        <div key={index} className={cn(styles['item'], styles[deviceType])}>
          <div className={cn(styles['bullet'], styles[`bullet--surface-${bulletSurface}`])}>{item.bullet}</div>
          <div className={cn(styles['text'], styles[deviceType])}>
            <div className={styles['title']}>
              <ItemTitle fontWeight="700">{item.title}</ItemTitle>
            </div>
            <Body1 color="text-secondary-default">{item.description}</Body1>
          </div>
        </div>
      ))}
    </div>
  );
};
